export enum TransitionType {
    Cut = `cut`,
    Dynamic = `dynamic`,
    SlideIn = `slidein`,
    SlideOut = `slideout`,
    Push = `push`,
    BarnDoor = `barndoor`,
    Wipe = `wipe`,
    Dip = `dip`
}

export enum AudioTransitionType {
    Crossfade = `crossfade`,
    VFade = `vFade`,
    Cut = `cut`
}

export enum DirectionType {
    Left = `right`,
    Right = `left`,
    Up = `up`,
    Down = `down`
}

export enum BarnDirectionType {
    Horizontal = `horizontal`,
    Vertical = `vertical`
}

//used when requesting creation
export type CustomTransitionRequest = {
    displayName: string;
    videoTransitionType: TransitionType;
    direction: DirectionType;
    audioTransitionType: AudioTransitionType;
    volume: number;
};

export type CustomTransitionResponse = {
    id: string;
    assetId: string;
    displayName: string;
    baseTransition?: {
        cutPoint: number;
        video: {
            type: TransitionType;
            attributes: {
                direction: DirectionType;
            };
        };
        audio: {
            type: AudioTransitionType;
        };
    };
    media: {
        previewUri: string;
        thumbnailURI: string;
        duration: number;
        audio: {
            volume: number;
        };
    };
};
